import { render, staticRenderFns } from "./AccountErrors.vue?vue&type=template&id=52565044&scoped=true"
import script from "./AccountErrors.vue?vue&type=script&lang=ts"
export * from "./AccountErrors.vue?vue&type=script&lang=ts"
import style0 from "./AccountErrors.vue?vue&type=style&index=0&id=52565044&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52565044",
  null
  
)

export default component.exports